const highway = {
  50: '#EBEBEB',
  100: '#CCCECE',
  200: '#ABADAE',
  300: '#898C8D',
  400: '#6F7374',
  500: '#565A5C',
  600: '#4F5254',
  700: '#45484A',
  800: '#3C3F41',
  900: '#2B2E30',
  A100: '#8AC0F6',
  A200: '#5AA7F3',
  A400: '#1B8DFF',
  A700: '#0280FF'
};

export default highway;
